<template>
    <div>
      <section class="duration">
      <div class="average-column-total">
          <div  class="avg-button" style="height: 33px;">
          </div>
          <div  class="avg-button-bottom">
                <span style="color:black">{{overDue.total}}<span id="label">&nbsp;Outliers</span></span>
          </div>
      </div>
      <div class="dashboard-buttons">
          <div class="tile-button average-column">
            <div class="average-column" @click="ShowOutlinerKits(4,'activated')">
              <div class="avg-button">
         
              </div>
              <div  class="avg-button-bottom">
              </div>
            </div>
            <div class="average-column" @click="ShowOutlinerKits(4,'activated')">
              <div class="awaiting avg-button">
                  <span  v-if="kitavg">{{kitavg.activated_to_intransit_date}}</span> 
              </div>
              <div  class="avg-button-bottom">
                  <span class="awaiting-span">{{overDue.awaiting_count}}</span> 
              </div>
            </div>
            <div class="average-column"  @click="ShowOutlinerKits(4,'awaiting')">
              <div class="received avg-button">
                  <span  v-if="kitavg">{{kitavg.intransit_to_lab_received_date}}</span> 
              </div>
              <div class="avg-button-bottom">
                  <span class="received-span">{{overDue.received_count}}</span> 
              </div>
            </div>
            <div class="average-column" @click="ShowOutlinerKits(4,'received')">
              <div class="completed avg-button">
                <span  v-if="kitavg">{{kitavg.lab_received_to_complete_date}}</span> 
              </div>
              <div class="avg-button-bottom">
                  <span class="completed-span">{{overDue.completed_total}}</span> 
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </template>
    
    <script>
    import { mapGetters,mapActions } from "vuex";
      export default {
        name: "AmazonDurationTimeline",
        data() {
         return {
           kitavg:{ordered_to_shipped_date:"0 Days 0 Hours",
                shipped_to_delivered_date:"0 Days 0 Hours",
                delivered_to_activated_date:"0 Days 0 Hours",
                activated_to_intransit_date:"0 Days 0 Hours",
                intransit_to_lab_received_date:"0 Days 0 Hours",
                lab_received_to_complete_date:"0 Days 0 Hours",
                },
           overDue:{ordered:0,
                total:0,
                shipped_count:0,
                delivered_count:0,
                activated_count:0,
                awaiting_count:0,
                received_count:0,
                completed_total:0,
                on_hold:0
                },
         }
      },
      computed: {
        ...mapGetters(['getTestKitAvg', 'getOverDues'])
      },
      methods: {
        ...mapActions(['testKitAvg', 'overDues', 'setOverDueByShipped', 'setOverDueByStyle']),
        sortbydays(e) {
          this.testKitAvg(e.target.value).then(res => {
          });
        },
        ShowOutlinerKits(steps,status,type = null)
        {
          this.setOverDueByShipped(type);
          if(type == null) {
            type = 'style';
          }
          this.setOverDueByStyle(status+type);
          this.$emit("showoutlinerkits",{ steps: steps, value: status});
        }
      },
      async mounted() {
        await this.testKitAvg();
        this.kitavg = this.$store.getters.getTestKitAvg;
        this.overDue = this.$store.getters.getOverDues;
      },
      watch: {
        getTestKitAvg(obj) {
          this.kitavg = obj;
        },
        getOverDues(obj) {
          this.overDue = obj;
        }
      }
      };
    </script>
    <style>
    
    
    .btn-filter-item {
     background-color: #fff;
      color: #000000;
      border: 1px solid transparent;
      -webkit-transition: all 0.5s linear;
      transition: all 0.5s linear;
    }
    .dashboard-buttons {
      display: flex;
      justify-content: center;
      width: 100%;
    }
    
    </style>
    
    <style lang="sass" scoped>
    @import "../../../styles/colors";
    *
      box-sizing: border-box
      font-family: TTNormsMedium, sans-serif;
      padding: 0
      margin: 0
      display: flex;
      justify-content: center;
      width: 100%;
     
    
    .shipping
      background-color:blue
    
    section.duration
      display: flex // Ensure flex is properly applied here
      .average-column-total
        color: white
        display: grid
        max-width: 100%
        text-align: right
        width: 90px
        padding-left: 20px;
    
      .dashboard-buttons
        .tile-button
          right: 52px;
          position: relative;
          display: flex;
          justify-content: center;
          list-style: none
          overflow: hidden
          font-size: 12px
          width: 100%;
          div.average-column-total
            color: white
            display: block
            max-width: 100%
            text-align: left
            width: 95px;
          div.average-column
            color: white
            display: block
            margin: 0px 10px 0px 10px
            text-align: center
            overflow: hidden
            cursor: pointer
            max-width: 236px;
            width: 100%;
          div.avg-button
                padding: 10px 0px 10px 0px
                border-radius: 100px
          div.avg-button-bottom
                padding: 20px 0px 10px 0px
                border-radius: 100px
                font-size: 14px
                font-weight: 500
          div.shipping
            background-color: $green
            font-size: 12px
          div.delivery
            background-color: $blue
            font-size: 12px
          div.activation
            background-color: $lightGray
            font-size: 12px
          div.awaiting
            background-color: $yellow
            font-size: 12px
          div.received
            background-color: $heather
            font-size: 12px
          div.completed
            background-color: $caribbeanBlue
            font-size: 12px
          span.shipping-span
            color: $green
          span.delivery-span
            color: $blue
          span.activation-span
            color: $lightGray
          span.awaiting-span
            color: $yellow
          span.received-span
            color: $heather
          span.completed-span
            color: $caribbeanBlue       
    .activation
        i
          font-size: 12px
          margin-bottom: 10px
    
    /* small */
    @media all and (min-width: 20em)
      p:after
        content: " small screens"
        color: darkslategray
        font-weight: 500
      .tile-button li
        width: 45.5%
        float: left
    
    
    /* large */
    @media all and (min-width: 40em)
      p:after
        content: " med screens && larger"
        color: darkslategray
        font-weight: 500
      .tile-button li
        width: 23%
    
    .shipped-column-cursor 
      cursor: context-menu !important;
    
    </style>